import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetInsightSchema, GetNpsResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GetNpsResponseDataSchema>>

type Params = z.input<typeof GetInsightSchema>

export const NPSQuery = (params: Params) => {
  return queryOptions({
    queryKey: ["nps", params],
    queryFn: async () => {
      const response = await axios.get<Response>(`/insights/nps`, { params })
      return response.data
    },
    staleTime: 1000 * 60 * 2,
  })
}
